<script lang="ts">
  export let title = 'Tech Lockdown';
</script>

<svelte:head>
  <title>{title} | Dashboard</title>
</svelte:head>
